module.exports = __webpack_public_path__ + "img/icon 7@3x.4d1f9330.png";